
import { Component, Prop, Provide, Vue } from 'vue-property-decorator'
import { apiShopLists } from '@/api/shop'
@Component
export default class Dialog extends Vue {
    visible = {
        val: false
    }

    page_no = 1
    list: any = []
    count = 0
    selected: any[] = []
    searchForm = {

        shop_info: ''

    }
    @Provide('visible')
    visibleVal = this.visible
    // props
    @Prop({ default: '600px' }) width!: string | number //弹窗的宽度
    @Prop({ default: 30 }) PageSize!: string | number //弹窗的宽度
    // data

    // methods
    handleEvent(type: 'cancel' | 'confirm') {
        this.$emit(type)
        this.close()
    }

    onTrigger() {
        this.open()
        this.getShopList()
    }
    changePage(val: number) {
        this.page_no = val
        this.getShopList()
    }
    getShopList() {
        apiShopLists({ page_size: this.PageSize, page_no: this.page_no }).then((res: any) => {
            this.list = res.lists
            this.count = res.count
        })
    }
    handleSelectionChange(value: any) {
        this.selected = value
    }
    close() {
        this.visible.val = false
        this.$emit('close')
    }
    open() {
        this.visible.val = true
        this.$emit('open')
    }
}
